<template>
  <div id="app" style="position:relative;">
    <!--<div style="position:fixed;width:100%;height:100%;background-color:rgba(255,255,255,0.5);z-index:101;">
      <pulse-loader :loading="true" :color="'#fc0'" :size="'40px'"></pulse-loader>
    </div>-->
    <navbar-overlay></navbar-overlay>
    <router-view class="page-wrapper"></router-view>
    <footer-main></footer-main>
    <fb-chat-now />
  </div>
</template>

<script>
// import Vue from 'vue'
import NavbarOverlay from '@/components/NavBarOverlay.vue'
import FooterMain from '@/components/Footer.vue'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import FbChatNow from '@/components/FBChatNow.vue'
// import EventBus from '@/controllers/EventBus'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'app',
  metaInfo: {
    title: 'noctorus',
    titleTemplate: '%s | noctorus.studio'
  },
  components: {
    NavbarOverlay,
    FooterMain,
    FbChatNow,
    PulseLoader
  },
  data () {
    return {

    }
  },
  computed: mapGetters([
    'isAuthenticated'
  ]),
  methods: {
    sample (data) {

    },
    // http://redux.js.org/docs/recipes/UsingObjectSpreadOperator.html
    ...mapActions([
      'authenticated',
      'unauthenticated'
    ])
  },
  beforeCreate () {
  },
  created () {
    console.log('created App.vue')
    // EventBus.$off('authenticated')
    // EventBus.$on('authenticated', (data) => {
    //   this.authenticated(data)
    // })
    // EventBus.$off('unauthenticated')
    // EventBus.$on('unauthenticated', () => {
    //   this.unauthenticated()
    // })
  },
  beforeMount () {
    console.log('beforeMount App.vue')
    window.addEventListener('load', () => {
      // console.log('beforeMount App.vue')
      // // https://developer.mozilla.org/en-US/docs/Web/API/CSS_Object_Model/Determining_the_dimensions_of_elements
      // console.log('win width:' + window.innerWidth)
      // console.log('app width:' + this.$el.clientWidth)
    })
  },
  mounted () {
    // // console.log('mounted App.vue')
    // window.fbAsyncInit = function () {
    //   /* global FB */
    //   FB.init({
    //     appId: '782732588553167',
    //     xfbml: true,
    //     version: 'v2.7'
    //   })
    //   window.FB = FB
    //   Object.defineProperty(Vue.prototype, '$FB', { value: FB })
    //   this.$FB.AppEvents.logPageView()
    //   console.log('init FB with ID in App.vue')
    // }.bind(this)
  }
}
</script>

<style lang="scss">
@import "./styles/app_setting.scss";

#app {
  /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
  font-family: $font-family;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: $color-text-main;
}

html.modal-open {
  overflow: hidden;
  position: relative;
  height: 100%;
  body {
    overflow: hidden;
    position: relative;
    height: 100%;
  }
}

.side-bar-wrapper {
  padding: 0px;
}

.side-bar {
  padding: 10px;
}

.page-wrapper {
  padding: 0px;
}

.page-landing.page-wrapper {
  padding: 0px;
}

</style>



// WEBPACK FOOTER //
// App.vue?052112bc